import { opinions } from '../defaults/opinions';

export const gemuesepasta = {
	name: 'Gemüsepasta mit Ruccola',
	desc: 'Frische Nudeln mit Gemüse angebraten. Auf kaltem Ruccola mit etwas Dressing serviert.',
	image: 1,
	benefits: [
		'2 von 5 empfohlenen Portionen Gemüse pro Tag',
		'Reich an Folsäure',
		'Fördert die Verdauung',
	],
	opinions: [
		{
			name: 'Jane Doe',
			date: '14. Januar 2017',
			title: 'Sehr lecker',
			content: 'Sehr lecker und frisch',
			rating: 4,
		},
		...opinions
	],
	warnings: ['gluten', 'weizen'],
	ingredients: [
		{'Nudeln': 'gluten'},
		'Paprika',
		'Schalotten',
		'Champignons',
		'Zucchini',
		'Knoblauch',
		'Piri-piri',
		'Salz',
		'Paprikapulver',
	],
};



// WEBPACK FOOTER //
// ./src/dishes/single-dishes/gemuesepasta.js